<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 12/10/2020
  -->

<template>
	<el-drawer
		:appendToBody="true"
		v-model="valueData"
		:close-on-press-escape="closeOnPressEscape"
		:wrapperClosable="wrapperClosable"
		:close-on-click-modal="wrapperClosable"
		:size="size"
		:modal="modal"
		:withHeader="false"
		@open="onDrawerOpened"
		@close="closeDrawer"
		direction="rtl">

<!--		<template #header="{ close, titleId, titleClass }">-->
			<div class="row mx-0 align-items-center px-3 pt-3" v-if="showCloseButton">
				<slot name="title">
					<div class="font-size-7" v-if="title">
						<qw-button-icon icon="icon-angle-left" @click="closeDrawer"/>{{ title }}
					</div>
				</slot>
				<div class="layout-spacer"></div>
				<button aria-label="close drawer"
						type="button"
						class="el-drawer__close-btn"
						@click="closeDrawer()">
					<i class="el-dialog__close el-icon fontello icon-cancel-1"></i>
				</button>
			</div>
			<slot name="title" v-else>
				<div class="font-size-7" v-if="title">
					<qw-button-icon icon="icon-angle-left" @click="closeDrawer"/> {{ title }}
				</div>
			</slot>


		<slot>
			<router-view v-bind="$attrs"/>
<!--			hi there-->
		</slot>
	</el-drawer>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";

export default {
	name: "qw-drawer",
	extends: BaseVModelView,
	props: {
		closeOnPressEscape: {Boolean, default: true},
		modal: {Boolean, default: true},
		size: {String, default: "85%"},
		parentRouteName: String,
		closeRouteName: String,
		showCloseButton: Boolean,
		title: String,
		wrapperClosable: {Boolean, default: true},
	},

	watch: {
		'$route.name': function (newValue) {
			console.log("$route.name changed: newValue = ", newValue, ", this.closeRouteName = ", this.closeRouteName, ", this.parentRouteName = ", this.parentRouteName, ", this.$route = ", this.$route)
			if (this.closeRouteName && newValue === this.closeRouteName) {
				if (this.parentRouteName && this.parentRouteName !== this.closeRouteName) {
					this.go(this.parentRouteName, this.$route.params, this.$route.query)
				}
				this.closeDrawer()
			}
		}
	},

	data() {
		return {
			modalZIndex: -1,
			modalOverlay: null
		}
	},


	methods: {

		onDrawerOpened() {
			this.notifyValueChanged()
		},

		closeDrawer() {
			this.$analyticManager.trackEvent("Drawer closed", this.analyticsPropsMethod())
			this.valueData = false
			this.notifyValueChanged()
			this.$emit("close")
		},

		onValueChanged(valueData) {
			console.log("onValueChanged: valueData = ", valueData)
			if (valueData) {
				this.$analyticManager.trackPageView(this.analyticsPropsMethod())
			}
		},

		analyticsPropsMethod() {
			return {
				category: "Drawer",
				title: this.title,
				...this.analyticsProps
			}
		}
	}
}
</script>

<style lang="scss">

</style>
